import React, { useState, useEffect } from "react";
import * as Style from "./styledComponents/PersonalInstruction";
import Safe from "../assets/images/DeathModuleNew/Sandglass&Bitcoin-1.png";
import SeeMore from "../assets/images/DeathModuleNew/more_horiz.png";
import menuIcon from "../assets/images/DeathModuleNew/Menu.png";
import fileIcon from "../assets/images/DeathModuleNew/Icons.png";
import helpIcon from "../assets/images/DeathModuleNew/IC_Help.png";
import AddModal from "./styledComponents/Modal/AddModal";
import UpdateModal from "./styledComponents/Modal/UpdateModal";
import Loader from "../components/styled-components/loader/loader";
import DEATH_API from "../apis/death.api";
import MODULE_API from "../apis/module.api";
import swal from "sweetalert";
import axios from "axios";
import List from "./styledComponents/Table/List";
import ListPaginated from "./styledComponents/Table/ListPaginated";
import moment from "moment";
import { Button, Icon, Row, Col, DatePicker, Form, Modal } from "antd";
import Table from "./styledComponents/Table/Table";
import ViewModal from "./styledComponents/Modal/ViewModal";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { ToolTipCreator } from "../helpers/ToolTipCreator";

export const EmailandText = (props) => {
  const emailCols = [
    {
      title: "To",
      dataIndex: "to",
      render: (record) => (record ? record : "N/A"),
      // render: (fileName,record) => {
      //   if (record && record.to) {
      //     return record.to;
      //   } else if (record && record.groupId) {
      //     const group = allGroups && allGroups.find(group => group.id === record.groupId);
      //     // console.log("here in group",group,record.groupId,allGroups)
      //     return group ? group.name : "N/A";
      //   } else {
      //     return "N/A";
      //   }
      // },
    },
    {
      title: "To Group",
      dataIndex: "to",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        if (record && record.groupId) {
          const group =
            allGroups && allGroups.find((group) => group.id === record.groupId);
          // console.log("here in group",group,record.groupId,allGroups)
          return group ? group.name : "N/A";
        } else {
          return "N/A";
        }
      },
    },
    {
      title: "Subject",
      dataIndex: "subject",
      //   sorter: (a, b) => a["lastName"] > b["lastName"],
      render: (record) => (record ? record : "N/A"),
    },
    {
      title: "Email Status",
      dataIndex: "status",
      // sorter: (a, b) => a["Phone"] > b["Phone"],
      render: (record) => (record ? record : "Not Sent"),
    },
    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                setDropDownEmail(false);
                setDropDownText(false);
                getSelectedEmailRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedEmailRow(record.id);

                          setDropdown(false);
                        }}
                      >
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateModal(true);
                          setDropdown(false);
                        }}
                      >
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        showHistoryModal(record.msgId);
                        setDropdown(false);
                      }}
                    >
                      History
                    </li>
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewModal(true);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const textCols = [
    {
      title: "To",
      dataIndex: "to",
      render: (record) => (record ? record : "N/A"),
      // render: (fileName,record) => {
      //   if (record && record.to) {
      //     return record.to;
      //   } else if (record && record.groupId) {
      //     const group = allGroups && allGroups.find(group => group.id === +record.groupId);
      //     console.log("here in group text",group,record.groupId,allGroups)
      //     return group ? group.name : "N/A";
      //   } else {
      //     return "N/A";
      //   }
      // },
    },
    {
      title: "To Group",
      dataIndex: "to",
      // render: (record) => (record ? record : "N/A"),
      render: (fileName, record) => {
        if (record && record.groupId) {
          const group =
            allGroups &&
            allGroups.find((group) => group.id === +record.groupId);
          // console.log("here in group",group,record.groupId,allGroups)
          return group ? group.name : "N/A";
        } else {
          return "N/A";
        }
      },
    },
    {
      title: "Text",
      dataIndex: "Template",
      render: (record) =>
        record
          ? record.replace(/<\/?[^>]+(>|$)/g, "").substring(0, 20) + "..."
          : "N/A",
    },
    {
      title: "Text Status",
      dataIndex: "sendStatus",
      render: (record) =>
        record ? (record === true ? "Sent" : "Not Sent") : "Not Sent",
    },
    {
      title: "Phone Number",
      dataIndex: "phoneNumber",
      render: (record) => (record ? formatPhoneNumber(record) : "N/A"),
    },
    {
      title: "Action",
      render: (record, index) => {
        // console.log("index...>>>",record.idx);
        return (
          <div>
            <div
              onClick={() => {
                setDropdown(!dropdown);
                setDropDownText(false);
                setDropDownEmail(false);
                getSelectedTextRow(record.id);
              }}
              style={{
                cursor: "pointer",
                marginRight: "1rem",
                padding: "0px 16px",
                width: "5px",
              }}
            >
              <img src={menuIcon} alt="menuIcon"></img>
            </div>
            {dropdown && selectedIndex === record.id && (
              <>
                <div
                  onClick={() => {
                    setDropdown(false);
                  }}
                  className=""
                  style={{
                    position: "fixed",
                    width: "100vw",
                    height: "100vh",
                    background: "black",
                    opacity: "0.1",
                    top: "0",
                    left: "0",
                    right: "0",
                    bottom: "0",
                    zIndex: "999",
                  }}
                ></div>

                <div class="dropdown" style={{ zIndex: "9999" }}>
                  <ul className="dropdownul">
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          deleteSelectedTextRow(record.id);
                          setDropdown(false);
                        }}
                      >
                        Delete
                      </li>
                    )}
                    {props.role !== "protrustee" && (
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowUpdateTextModal(true);
                          setDropdown(false);
                        }}
                      >
                        Update
                      </li>
                    )}
                    <li
                      className="liHover"
                      onClick={() => {
                        setShowViewTextModal(true);
                        setDropdown(false);
                      }}
                    >
                      View
                    </li>
                  </ul>
                </div>
              </>
            )}{" "}
          </div>
        );
      },
    },
  ];
  const LogsCountCols = [
    {
      title: "No. Of Emails Sent",
      dataIndex: "Send",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "No. Of Emails Bounce",
      dataIndex: "Bounce",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "No. Of Emails Delivered",
      dataIndex: "Delivery",
      render: (record) => (record ? record : "0"),
    },
    {
      title: "Emails Opened",
      dataIndex: "Open",
      render: (record) => (record ? record : "0"),
    },
  ];
  const [email_field, setemail_field] = useState([
    // {
    //   title: "To",
    //   type: "emails",
    //   index: "To",
    // },
    {
      title: "To",
      type: "selectEmail",
      options: contactList && contactList,
      index: "To",
    },
    {
      title: "To Group",
      type: "select",
      options: allGroupsName && allGroupsName,
      index: "ToGroup",
    },
    {
      title: "Subject",
      type: "input",
      index: "Subject",
    },

    {
      title: "Templates",
      type: "select",
      options: templateValue && templateValue.length > 0 && templateValue,
      index: "Templates",
    },
    {
      title: "Body of Email",
      type: "richtext1",
      index: "Template",
    },
  ]);
  const [textFields, setTextFields] = useState([
    // {
    //   title: "To",
    //   type: "input",
    //   index: "TextTo",
    // },
    {
      title: "To",
      type: "selectNumber",
      options: contactListText && contactListText,
      index: "TextTo",
    },
    {
      title: "To Group",
      type: "select",
      options: allGroupsName && allGroupsName,
      index: "ToGroup",
    },
    {
      title: "Phone",
      type: "phoneNumber",
      index: "Phone",
    },
    {
      title: "Templates",
      type: "select",
      options:
        templateValueText && templateValueText.length > 0 && templateValueText,
      index: "TextTemplates",
    },
    {
      title: "Body of Template",
      type: "richtext2",
      index: "Template",
    },
  ]);
  const [updateEmailFields, setUpdateEmailFields] = useState([
    // {
    //   title: "To",
    //   type: "input",
    //   index: "to",
    // },
    {
      title: "To",
      type: "selectEmail",
      options: contactList && contactList,
      index: "To",
    },
    {
      title: "To Group",
      type: "select",
      options: allGroupsName && allGroupsName,
      index: "ToGroup",
    },
    {
      title: "Subject",
      type: "input",
      index: "subject",
    },

    {
      title: "Templates",
      type: "select",
      options: templateValue && templateValue.length > 0 && templateValue,
      index: "Templates",
    },
    {
      title: "Body of Email",
      type: "richtext1",
      index: "Template",
    },
  ]);
  const [updateTextFields, setUpdateTextFields] = useState([
    // {
    //   title: "TextTo",
    //   type: "input",
    //   index: "to",
    // },
    {
      title: "TextTo",
      type: "selectNumber",
      options: contactListText && contactListText,
      index: "to",
    },
    {
      title: "Phone",
      type: "phoneNumber",
      index: "phoneNumber",
    },
    {
      title: "To Group",
      type: "select",
      options: allGroupsName && allGroupsName,
      index: "ToGroup",
    },
    {
      title: "Templates",
      type: "select",
      options:
        templateValueText && templateValueText.length > 0 && templateValueText,
      index: "TextTemplates",
    },
    {
      title: "Body of Template",
      type: "richtext2",
      index: "Template",
    },
  ]);
  const UpdateEmailFields = [
    {
      title: "To",
      type: "input",
      index: "to",
    },

    {
      title: "Subject",
      type: "input",
      index: "subject",
    },

    {
      title: "Templates",
      type: "select",
      options: templateValue && templateValue.length > 0 && templateValue,
      index: "Templates",
    },
    {
      title: "Body of Email",
      type: "richtext1",
      index: "Template",
    },
  ];

  const UpdateTextFields = [
    {
      title: "TextTo",
      type: "input",
      index: "to",
    },
    {
      title: "Phone",
      type: "phoneNumber",
      index: "phoneNumber",
    },

    {
      title: "Templates",
      type: "select",
      options:
        templateValueText && templateValueText.length > 0 && templateValueText,
      index: "TextTemplates",
    },
    {
      title: "Body of Template",
      type: "richtext2",
      index: "Template",
    },
  ];
  const [emails, setEmails] = useState([]);
  const [text, setText] = useState([]);
  const [logsCount, setLogsCount] = useState([]);
  const [funeralData, setFuneralData] = useState({});
  const [templateValueText, setTemplateValueText] = useState([""]);
  const [templateValue, setTemplateValue] = useState([]);
  const [isHistoryModalOpen, setIsHistoryModalOpen] = useState(false);
  const [emailLogs, setEmailLogs] = useState([]);

  const handleHistoryCancel = () => {
    setIsHistoryModalOpen(false);
  };

  const showHistoryModal = async (msgId) => {
    console.log("email to send in api", msgId);
    try {
      setLoading(true);
      // const ID = localStorage.getItem("accessId")
      const data = await DEATH_API.getEmailHistory(msgId);
      console.log("data in death status", data);
      if (data && data.emailLogsGenerated) {
        console.log("here in email history fetching");
        setEmailLogs(data.emailLogsGenerated);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log("error");
      // throw new Error(error);
    }
    setIsHistoryModalOpen(true);
  };

  const [loading, setLoading] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [showUpdateModal, setShowUpdateModal] = useState(false);
  const [showUpdateTextModal, setShowUpdateTextModal] = useState(false);
  const [emailTemplateData, setEmailTemplateData] = useState({});
  const [textTemplateData, setTextTemplateData] = useState({});

  const [addData, setaddData] = useState({});
  const [updateObject, setUpdateObject] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [addEmailTemplate, setAddEmailTemplate] = useState(false);
  const [addTextTemplate, setAddTextTemplate] = useState(false);
  const [dropDownEmail, setDropDownEmail] = useState(false);
  const [dropDownText, setDropDownText] = useState(false);
  const [clinetFuneralData, setClinetFuneralData] = useState({});
  const [textButton, setTextButton] = useState(true);
  const [emailButton, setEmailButton] = useState(true);
  const [contactList, setContactList] = useState([]);
  const [contactListText, setContactListText] = useState([]);
  const [allGroups, setAllGroups] = useState([]);
  const [allGroupsName, setAllGroupsName] = useState([]);
  const [showModal, setShowModal] = useState(false);
  const [tooltipModal, setTooltipModal] = useState(false);
  const [tooltipTextModal, setTooltipTextModal] = useState(false);
  const [tooltipEmailModal, setTooltipEmailModal] = useState(false);

  const [showViewModal, setShowViewModal] = useState(false);
  const handelCloseViewModal = () => {
    setShowViewModal(false);
  };
  const [showViewTextModal, setShowViewTextModal] = useState(false);
  const handelCloseViewTextModal = () => {
    setShowViewTextModal(false);
  };

  const closeEmailTemplateModal = () => {
    setAddEmailTemplate(false);
  };
  const closeTextTemplateModal = () => {
    setAddTextTemplate(false);
  };
  const saveEmailTemplateModal = async () => {
    setAddEmailTemplate(false);
    setLoading(true);

    let data = emailTemplateData;
    let arr = [data];
    console.log("data template", arr);
    // console.log("data template", Array.isArray(data));

    if (Array.isArray(arr) && arr.length > 0) {
      const res = await DEATH_API.postTemplate({
        templates: arr.map((item) => {
          return {
            templateName: item.name,
            template: item.template,
          };
        }),
      });
      console.log("tempalte creating", res);
      if (res.status === 200) {
        swal(
          "Success",
          "Your template has been created. Add an email and use the Templates dropdown to use. Edit if you wish.",
          "success"
        );
      }
    }
    setLoading(false);
    getEmailTemplate();
  };
  const saveTextTemplateModal = async () => {
    setAddTextTemplate(false);
    let data = textTemplateData;
    let arr = [data];
    console.log("data template", arr);
    // console.log("data template", Array.isArray(data));

    setLoading(true);
    if (Array.isArray(arr) && arr.length > 0) {
      let resText = await DEATH_API.postTextTemplate({
        templates: arr.map((item) => {
          return {
            templateName: item.name,
            template: item.template,
          };
        }),
      });
      console.log("tempalte creating");
      if (resText.status === 200) {
        swal(
          "Success",
          "Your template has been created. Add a text message and click the Templates dropdown to use. Edit if you wish.",
          "success"
        );
      }
    }
    setLoading(false);
    getTextTemplate();
  };

  const updateEmailRow = async () => {
    console.log("this.state.updateObject email", updateObject);
    try {
      setLoading(true);
      if (updateObject.email_template) {
        updateObject.email_template.template =
          updateObject.Template && updateObject.Template;
      }
      let groupId = null;
      if (updateObject && updateObject.ToGroup) {
        groupId = allGroups.find(
          (group) => group.name === updateObject.ToGroup
        ).id;
      }
      console.log("updated email obj 11", groupId);
      let obj = {
        ...updateObject,
        id: updateObject.id && updateObject.id,
        to: updateObject.To && updateObject.To,
        cc: "",
        relationship: "",
        subject: updateObject.subject && updateObject.subject,
        templateName: updateObject.TemplateNickName
          ? updateObject.TemplateNickName
          : "",
        emailBody: updateObject.Template ? updateObject.Template : "",
        groupId: groupId && groupId,
        // emailTemplateId:
        //   (updateObject.emailTemplateId && +updateObject.emailTemplateId) ||
        //   updateObject.email_template.id && +updateObject.email_template.id,
      };

      console.log("before api call", obj);
      await DEATH_API.updateEmail(obj.id, obj);
      setLoading(false);
      getEmails();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  //  function to update a specific Text row
  const updateTextRow = async () => {
    console.log("upadteObjctete", updateObject);
    try {
      setLoading(true);
      if (updateObject.text_template) {
        updateObject.text_template.template =
          updateObject.Template && updateObject.Template;
      }
      let groupId = null;
      if (updateObject && updateObject.ToGroup) {
        groupId = allGroups.find(
          (group) => group.name === updateObject.ToGroup
        ).id;
      }
      console.log("updateObject.....", groupId);
      let obj = {
        ...updateObject,
        to: updateObject.TextTo && updateObject.TextTo,
        phoneNumber: updateObject.Phone && updateObject.Phone,
        // subject: updateObject.Subject && updateObject.Subject,
        // relationship:updateObject.Relationship && updateObject.Relationship,
        relationship: "",
        text_template_id:
          (updateObject.text_template &&
            updateObject.text_template.id &&
            +updateObject.text_template.id) ||
          (updateObject.textTemplateId && +updateObject.textTemplateId),
        // (updateObject.textTemplateId && +updateObject.textTemplateId) ||
        // updateObject.text_template.id && updateObject.text_template.id,
        textTemplateId:
          updateObject.textTemplateId && +updateObject.textTemplateId,
        // (updateObject.textTemplateId && +updateObject.textTemplateId) ||
        // updateObject.text_template.id && +updateObject.text_template.id,
        textBody: updateObject.Template ? updateObject.Template : "",
        templateName: updateObject.TextTemplates && updateObject.TextTemplates,
        TextTemplates: updateObject.TextTemplates && updateObject.TextTemplates,
        message: updateObject.TextMessage && updateObject.TextMessage,
        groupId: groupId && groupId,
      };

      console.log("update text object", obj);
      await DEATH_API.updateText(obj.id, obj);
      setLoading(false);
      getText();
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  useEffect(() => {
    setemail_field([
      // {
      //   title: "To",
      //   type: "emails",
      //   index: "To",
      // },
      {
        title: "To",
        type: "selectEmail",
        options: contactList && contactList,
        index: "To",
      },
      {
        title: "To Group",
        type: "select",
        options: allGroupsName && allGroupsName,
        index: "ToGroup",
      },
      {
        title: "Subject",
        type: "input",
        index: "Subject",
      },

      {
        title: "Templates",
        type: "select",
        // options: templateValue && templateValue.length > 0 ? templateValue : ["N/A"],
        options: templateValue || "N/A",
        index: "Templates",
      },
      {
        title: "Body of Email",
        type: "richtext1",
        index: "Template",
      },
    ]);
    setUpdateEmailFields([
      // {
      //   title: "To",
      //   type: "input",
      //   index: "to",
      // },
      {
        title: "To",
        type: "selectEmail",
        options: contactList && contactList,
        index: "To",
      },
      {
        title: "To Group",
        type: "select",
        options: allGroupsName && allGroupsName,
        index: "ToGroup",
      },
      {
        title: "Subject",
        type: "input",
        index: "subject",
      },

      {
        title: "Templates",
        type: "select",
        options: templateValue && templateValue.length > 0 && templateValue,
        index: "Templates",
      },
      {
        title: "Body of Email",
        type: "richtext1",
        index: "Template",
      },
    ]);
    // console.log("updateing emailfields",emailFields)
  }, [templateValue, contactList, allGroupsName]);
  useEffect(() => {
    setTextFields([
      // {
      //   title: "To",
      //   type: "input",
      //   index: "TextTo",
      // },
      {
        title: "To",
        type: "selectNumber",
        options: contactListText && contactListText,
        index: "TextTo",
      },
      {
        title: "Phone",
        type: "phoneNumber",
        index: "Phone",
      },
      {
        title: "To Group",
        type: "select",
        options: allGroupsName && allGroupsName,
        index: "ToGroup",
      },
      // {
      //   title: "Relationship",
      //   type: "select",
      //   options: ["Abc", "Def", "Others"],
      //   index: "TextRelationship"
      // },
      {
        title: "Templates",
        type: "select",
        options:
          templateValueText &&
          templateValueText.length > 0 &&
          templateValueText,
        index: "TextTemplates",
      },
      {
        title: "Body of Template",
        type: "richtext2",
        index: "Template",
      },
    ]);
    setUpdateTextFields([
      // {
      //   title: "TextTo",
      //   type: "input",
      //   index: "to",
      // },
      {
        title: "TextTo",
        type: "selectNumber",
        options: contactListText && contactListText,
        index: "to",
      },
      {
        title: "Phone",
        type: "phoneNumber",
        index: "phoneNumber",
      },
      {
        title: "To Group",
        type: "select",
        options: allGroupsName && allGroupsName,
        index: "ToGroup",
      },
      {
        title: "Templates",
        type: "select",
        options:
          templateValueText &&
          templateValueText.length > 0 &&
          templateValueText,
        index: "TextTemplates",
      },
      {
        title: "Body of Template",
        type: "richtext2",
        index: "Template",
      },
    ]);
    // console.log("updateing emailfields",emailFields)
  }, [templateValueText, contactListText, allGroupsName]);
  const showTooltipModal = () => {
    setTooltipModal(true);
  };

  const handleTooltipCancel = () => {
    setTooltipModal(false);
  };
  const showTooltipTextModal = () => {
    setTooltipTextModal(true);
  };

  const handleTooltipTextCancel = () => {
    setTooltipTextModal(false);
  };
  const showTooltipEmailModal = () => {
    setTooltipEmailModal(true);
  };

  const handleTooltipEmailCancel = () => {
    setTooltipEmailModal(false);
  };
  const [showTextModal, setTextShowModal] = useState(false);
  const handelCloseTextModal = () => {
    setTextShowModal(false);
  };

  const handlechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handlePhoneChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };

  const handleRichTextChange = (name, value) => {
    console.log("richtext value", value);
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdateRichTextChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdatePhoneChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleDocumentChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleDatePickerChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleRadioChange = (name, value) => {
    setaddData({
      ...addData,
      [name]: value,
    });
  };
  const handleUpdatechange = (e) => {
    console.log("e", e.target);
    e.preventDefault();
    const { name, value } = e.target;

    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDocumentChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateDatePickerChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleUpdateRadioChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      [name]: value,
    });
  };
  const handleSelectChange = (name, value) => {
    console.log("namename", name, extractEmail(value), value);
    if (name === "To") {
      console.log("here in calling", value);
      setaddData({
        ...addData,
        [name]: extractEmail(value),
      });
    } else if (name === "TextTo") {
      console.log("here in calling text", value);
      const hasPhoneNumber = /\+\d+/.test(value);
      if (hasPhoneNumber) {
        setaddData({
          ...addData,
          ["To"]: extractName(value),
          ["Phone"]: extractPhoneNumber(value),
        });
      } else {
        setaddData({
          ...addData,
          ["To"]: value,
        });
      }
    } else {
      console.log("here in calling else case");
      setaddData({
        ...addData,
        [name]: value,
      });
    }
  };
  const extractName = (fullNamePhoneString) => {
    // Assuming the name is at the beginning of the string
    const parts = fullNamePhoneString.split(" ");

    // Extract the name by joining all elements except the last two
    const name = parts.slice(0, -2).join(" ");

    return name;
  };
  const extractPhoneNumber = (fullNamePhoneString) => {
    const parts = fullNamePhoneString.split(" ");

    // Extract the last two elements as the country code and phone number
    const countryCode = parts[parts.length - 2];
    const phoneNumber = parts[parts.length - 1];

    // Concatenate the country code and phone number
    const completePhoneNumber = `${countryCode} ${phoneNumber}`;

    return completePhoneNumber;
  };
  const extractEmail = (fullNameEmailString) => {
    // Split the string into an array using space as the delimiter
    const parts = fullNameEmailString.split(" ");

    // Extract the last element as the email
    const email = parts[parts.length - 1];

    return email;
  };
  const handleSelectTemplateChange = (name, value) => {
    setaddData({
      ...addData,
      ["emailTemplateId"]: value,
    });
  };
  const handleSelectUpdateTemplateChange = (name, value) => {
    setUpdateObject({
      ...updateObject,
      ["emailTemplateId"]: value,
    });
  };
  const handleSelectTextTemplateChange = (name, value) => {
    setaddData({
      ...addData,
      ["textTemplateId"]: value,
    });
  };
  const handleSelectUpdateTextTemplateChange = (name, value) => {
    console.log("upadtetemplteid textTemplateId", value);
    setUpdateObject({
      ...updateObject,
      ["textTemplateId"]: value,
    });
  };
  const handleUpdateSelectChange = (name, value) => {
    console.log("namename", name);
    if (name === "To") {
      setUpdateObject({
        ...updateObject,
        [name]: extractEmail(value),
      });
    } else if (name === "to") {
      const hasPhoneNumber = /\+\d+/.test(value);
      if (hasPhoneNumber) {
        setUpdateObject({
          ...updateObject,
          ["to"]: extractName(value),
          ["TextTo"]: extractName(value),
          ["Phone"]: extractPhoneNumber(value),
          ["phoneNumber"]: extractPhoneNumber(value),
        });
      } else {
        setUpdateObject({
          ...updateObject,
          ["to"]: value,
          ["TextTo"]: value,
        });
      }
    } else {
      setUpdateObject({
        ...updateObject,
        [name]: value,
      });
    }
  };
  const SubmitUpdate = () => {
    console.log("updated object submit", updateObject);
    updateEmailRow();
    handelCloseUpdateModal();
  };
  const SubmitTextUpdate = () => {
    console.log("updated object submit", updateObject);
    updateTextRow();
    handelCloseUpdateTextModal();
  };
  const submitData = () => {
    console.log("submit data>>", addData);
    createEmailRow();
    handelCloseModal();
  };
  const submitTextData = () => {
    console.log("submit data", addData);
    createTextRow();
    handelCloseTextModal();
    setaddData({});
  };
  const handelCloseModal = () => {
    setShowModal(false);
    setaddData({});
  };
  const handelCloseUpdateModal = () => {
    setShowUpdateModal(false);
  };
  const handelCloseUpdateTextModal = () => {
    setShowUpdateTextModal(false);
  };

  function formatPhoneNumber(phoneWithCountryCode) {
    // Remove any non-numeric characters from the phone number
    const numericPhoneNumber = phoneWithCountryCode.replace(/\D/g, "");
    if (
      numericPhoneNumber.startsWith("1") &&
      numericPhoneNumber.length === 11
    ) {
      // Format as a USA number (e.g., +1 408-123-4567)
      return `+1 ${numericPhoneNumber.slice(1, 4)}-${numericPhoneNumber.slice(
        4,
        7
      )}-${numericPhoneNumber.slice(7)}`;
    } else if (
      numericPhoneNumber.startsWith("44") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a UK number (e.g., +44 20 1234 5678)
      return `+44 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        8
      )} ${numericPhoneNumber.slice(8)}`;
    } else if (
      numericPhoneNumber.startsWith("49") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Germany number (e.g., +49 30 12345678)
      return `+49 ${numericPhoneNumber.slice(2, 4)} ${numericPhoneNumber.slice(
        4,
        12
      )}`;
    } else if (
      numericPhoneNumber.startsWith("92") &&
      numericPhoneNumber.length === 12
    ) {
      // Format as a Pakistan number (e.g., +92 300 1234567)
      return `+92 ${numericPhoneNumber.slice(2, 5)} ${numericPhoneNumber.slice(
        5,
        12
      )}`;
    } else {
      return phoneWithCountryCode;
    }
  }

  // const getSelectedEmailRow = (idx) => {
  //   console.log("idx", idx);
  //   setSelectedIndex(idx);
  //   // get selected row (this will return array of object)
  //   let selectedRow = emails.filter((row, index) => {
  //     return row.id == idx;
  //   });

  //   // get first and only element from list and store it in update object
  //   console.log("selectedRow", selectedRow[0]);
  //   setUpdateObject(selectedRow[0]);
  // };
  const getSelectedEmailRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    let selectedRow = emails.find((row) => row.id === idx);
    if (selectedRow.groupId !== undefined || selectedRow.groupId !== null) {
      const groupId = selectedRow.groupId;

      const selectedGroup = allGroups.find((group) => group.id === groupId);
      if (selectedGroup) {
        selectedRow.ToGroup = selectedGroup.name;
      } else {
        console.log("Group not found for groupId:", groupId);
      }
    } else {
      console.log("selectedRow does not contain groupId property.");
    }
    // Store the selected row in the update object
    console.log("selectedRow", selectedRow);
    setUpdateObject(selectedRow);
  };

  const getSelectedTextRow = (idx) => {
    console.log("idx", idx);
    setSelectedIndex(idx);
    // get selected row (this will return array of object)
    let selectedRow = text.find((row) => row.id === idx);
    if (selectedRow.groupId !== undefined || selectedRow.groupId !== null) {
      const groupId = selectedRow.groupId;

      const selectedGroup = allGroups.find((group) => group.id === +groupId);
      if (selectedGroup) {
        selectedRow.ToGroup = selectedGroup.name;
      } else {
        console.log("Group not found for groupId:", groupId);
      }
    } else {
      console.log("selectedRow does not contain groupId property.");
    }
    // Store the selected row in the update object
    console.log("selectedRow", selectedRow);
    setUpdateObject(selectedRow);

    // let selectedRow = text.filter((row, index) => {
    //   return row.id == idx;
    // });

    // // get first and only element from list and store it in update object
    // console.log("selectedRow", selectedRow[0]);
    // setUpdateObject(selectedRow[0]);
  };
  const createEmailRow = async () => {
    // check if already formData contains some data then initialize it with empty
    let groupId = null;
    if (addData && addData.ToGroup) {
      groupId = allGroups.find((group) => group.name === addData.ToGroup).id;
    }
    console.log("addData", addData, allGroups, groupId);
    var arr = [addData];
    try {
      let data;
      data = arr;
      console.log("data in email", data);
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      if (Array.isArray(data) && data.length > 0) {
        await DEATH_API.addEmail({
          emailToSend: data.map((item) => {
            return {
              to: groupId ? null : item.To,
              subject: item.Subject,
              emailTemplateId: +item.emailTemplateId,
              emailBody: item.Template,
              groupId: groupId && groupId,
            };
          }),
        });
        await getEmails();
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);

      throw new Error(error);
    }
    setaddData({});
  };
  const createTextRow = async () => {
    let groupId = null;
    if (addData && addData.ToGroup) {
      groupId = allGroups.find((group) => group.name === addData.ToGroup).id;
    }

    var arr = [addData];
    console.log("adddata", addData);
    try {
      let data;
      data = arr;
      console.log("data in email", data);
      setLoading(true);
      console.log("textdata", data);
      if (Array.isArray(data) && data.length > 0) {
        await DEATH_API.addText({
          textToSend: data.map((item) => {
            return {
              to: item.To,
              phoneNumber: item.Phone,
              // subject: item.Subject,
              // relationship: item.TextRelationship,
              textTemplateId: +item.textTemplateId,
              textBody: item.Template,
              templateName: item.TextTemplateNickname,
              message: item.TextMessage,
              groupId: groupId && groupId,
            };
          }),
        });
      }
      setLoading(false);
      await getText();
    } catch (error) {
      console.log(error);
      setLoading(false);
      throw new Error(error);
    }
    setaddData({});
  };

  const deleteSelectedEmailRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      confirmButtonColor: "#2a3da3",
      cancelButtonColor: "white",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);
          await DEATH_API.deleteEmail(idx);
          setLoading(false);

          getEmails();
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(false);
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const deleteSelectedTextRow = async (idx) => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to delete this?",
      dangerMode: true,
      buttons: ["No, cancel it!", "Yes, delete it!"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        try {
          setLoading(true);

          await DEATH_API.deleteText(idx);

          setLoading(false);
          getText();
        } catch (error) {
          setLoading(false);
          console.log(error);
        }
        setTimeout(async () => {
          setLoading(false);
          swal("Deleted!", "Your file has been deleted.", "success");
        }, 0);
      } else {
        swal("Cancelled", "Your file is safe :)", "error");
      }
    });
  };
  const getContactList = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let data = await DEATH_API.fetchContactList(ID);
      setContactList([]);
      setContactListText([]);
      if (data && data.data) {
        console.log("data in conatct", data.data[0].contacts);
        const simplifiedContacts = data.data[0].contacts.map((item, idx) => ({
          firstName: item.firstName && item.firstName,
          lastName: item.lastName && item.lastName,
          email: item.email,
          phone: `${item.primaryCountryCode} ${item.phoneNumber}`,
          idx: idx + 1,
          id: item.id,
        }));
        console.log("contactlist data", simplifiedContacts);
        const stringArray = simplifiedContacts.map(
          (contact) =>
            `${contact.firstName} ${contact.lastName} ${contact.email}`
        );
        console.log("stringArray", stringArray);
        const stringArrayText = simplifiedContacts.map(
          (contact) =>
            `${contact.firstName} ${contact.lastName} ${contact.phone}`
        );
        console.log("stringArray", stringArrayText);
        setContactList(stringArray);
        setContactListText(stringArrayText);
      }
      setLoading(false);
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };
  const getGroups = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      let apiResponse = await DEATH_API.getGroups(ID);
      console.log("apiResponse", apiResponse);
      if (apiResponse && apiResponse.groups) {
        setAllGroups(apiResponse.groups);
        const groupNames = apiResponse.groups.map((group) => group.name);
        setAllGroupsName(groupNames);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getEmails = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.fetchEmail(ID);
      if (data && data.data) {
        data.data.map(
          (item, index) => (
            (item["To"] = item.to),
            (item["CC"] = item.cc),
            (item["Subject"] = item.subject),
            (item["TemplateNickName"] =
              item.email_template && item.email_template.templateName),
            (item["Template"] =
              (item.emailBody && item.emailBody) ||
              (item.email_template && item.email_template.template)),
            (item["Templates"] =
              item.email_template && item.email_template.templateName),
            (item["sendStatus"] = item.sendStatus),
            (item["emailTemplateId"] =
              item.email_template && item.email_template.id)
          )
        );
        console.log("allemails", data.data);
        // setEmails((prevState) => [...prevState, ...data.data]);
        setEmails(data.data);
        data.data.map((item, index) => {
          if (item.sendStatus === false) {
            setEmailButton(item.sendStatus);
          }
        });
      }

      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getText = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const data = await DEATH_API.fetchText(ID);
      if (data && data.data) {
        data.data.map(
          (item, index) => (
            (item["TextTo"] = item.to),
            (item["Phone"] = item.phoneNumber),
            (item["Subject"] = item.subject),
            (item["Relationship"] = item.relationship),
            (item["TextTemplateNickname"] = item.templateName),
            (item["TextMessage"] = item.message),
            (item["Template"] =
              (item.textBody && item.textBody) ||
              (item.text_template && item.text_template.template)),
            (item["textTemplateId"] =
              item.text_template && item.text_template.id),
            (item["TextTemplates"] =
              item.text_template && item.text_template.templateName)
          )
        );

        setText(data.data);

        data.data.map((item, index) => {
          if (item.sendStatus === false) {
            setTextButton(item.sendStatus);
          }
        });
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const getFuneralInfo = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      if (props.role === "protrustee") {
        const data = await DEATH_API.getFuneralInfo(ID);
        console.log("data funeral info", data);
        if (data && data.data) {
          setFuneralData(data.data);
        }
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getEmailTemplate = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      setTemplateValue([]);
      const datatemp = await DEATH_API.getTemplate();
      // console.log("datatempdatatempdatatemp>>",datatemp);
      if (datatemp && datatemp.data) {
        datatemp.data.map(
          (item, index) => (
            (item["id"] = item.id), (item["name"] = item.templateName)
          )
        );
        setTemplateValue((prevState) => [...prevState, ...datatemp.data]);
        console.log("datatemp.data", datatemp.data);
      }
      else {
        // If datatemp.data is empty or undefined, set "N/A"
        setTemplateValue((prevState) => [
          {
            id: "N/A",
            name: (
              <div
                style={{
                  width: "100%",
                  margin: "0",
                  padding: "0",
                }}
              >
                <input
                  type="text"
                  placeholder="No Templates yet. Create one first, then return here."
                  disabled={true}
                  readOnly
                  style={{
                    textAlign: "center",
                    width: "100%",
                    cursor: "not-allowed",
                    padding: "6px 0",
                    border: "none",
                    outline: "none",
                  }}
                />
              </div>
            ),
          },
        ]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  console.log(
    "templateValue1223",
    templateValue && templateValue.length > 0 && templateValue
  );
  const getTextTemplate = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      setTemplateValueText([]);

      const datatemp = await DEATH_API.getTextTemplate();
      // console.log("datatempdatatempdatatemp>>",datatemp);
      if (datatemp && datatemp.data) {
        datatemp.data.map(
          (item, index) => (
            (item["id"] = item.id), (item["name"] = item.templateName)
          )
        );
        setTemplateValueText((prevState) => [...prevState, ...datatemp.data]);
      } else {
        // If datatemp.data is empty or undefined, set "N/A"
        setTemplateValueText((prevState) => [
          {
            id: "N/A",
            name: (
              <div
                style={{
                  width: "100%",
                  margin: "0",
                  padding: "0",
                }}
              >
                <input
                  type="text"
                  placeholder="No Templates yet. Create one first, then return here."
                  disabled={true}
                  readOnly
                  style={{
                    textAlign: "center",
                    width: "100%",
                    cursor: "not-allowed",
                    padding: "6px 0",
                    border: "none",
                    outline: "none",
                  }}
                />
              </div>
            ),
          },
        ]);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  const getLogsCount = async () => {
    try {
      setLoading(true);
      const ID = localStorage.getItem("accessId");
      const dataTable = await DEATH_API.getEmailCounts(ID);
      if (dataTable && dataTable.countEmailLogs) {
        console.log("here in email table fetching", dataTable.countEmailLogs);

        const statusCountObject = {};
        dataTable.countEmailLogs.forEach((item) => {
          statusCountObject[item.status] = item.count;
        });
        let wrapper = [statusCountObject];
        console.log("wrapper", wrapper);
        setLogsCount(wrapper);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };
  useEffect(() => {
    console.log("calling api");
    // getEmails();
    // getText();
    // getFuneralInfo();
    // getEmailTemplate();
    // getTextTemplate();
    // getLogsCount();
    getAll();
  }, []);
  const getAll = async () => {
    await getGroups();
    await getEmails();
    await getText();
    await getFuneralInfo();
    await getEmailTemplate();
    await getTextTemplate();
    await getLogsCount();
    await getContactList();
  };

  const handleFormDateChange = (name, date, dateString) => {
    console.log("name, date,", name, date, dateString);
    // this.setState({
    //   clinetFuneralData: {
    //     ...this.state.clinetFuneralData,
    //     [name]: dateString,
    //   },
    // });
    setClinetFuneralData((prevFormData) => ({
      ...prevFormData,
      [name]: dateString,
    }));
  };

  const handleFunearlChange = (event) => {
    const { name, value } = event.target;
    // this.setState({
    //   clinetFuneralData: {
    //     ...this.state.clinetFuneralData,
    //     [name]: value,
    //   },
    // });
    setClinetFuneralData((prevFormData) => ({
      ...prevFormData,
      [name]: value,
    }));
  };
  const submitForm = async () => {
    console.log("client funeral", clinetFuneralData);
    let payload = {};
    if (funeralData) {
      payload = clinetFuneralData;
      payload.clientId = +localStorage.getItem("accessId");
      payload.id = +funeralData.id;
    } else {
      payload = clinetFuneralData;
      payload.clientId = +localStorage.getItem("accessId");
    }
    setLoading(true);
    let api_res = await DEATH_API.postFuneralInfo(payload);
    setLoading(false);
    console.log("api_res", api_res);
  };

  const sendAllEmails = async () => {
    let resMessage = null;
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to send all emails?",
      dangerMode: true,
      buttons: ["No!", "Yes"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        console.log("inside confirm status");
        try {
          const ID = localStorage.getItem("accessId");
          setLoading(true);
          resMessage = await DEATH_API.SendEmails({
            type: "email",
            clientId: +ID,
          });
          console.log("resMessage", resMessage);
          // resMessage=res;
          setLoading(false);
          setEmailButton(true);
          await getEmails();
          // swal("Success!", res.message, "success");
          // return api_res;
        } catch (error) {
          setLoading(false);
          console.log(error);
          throw new Error(error);
        }
        setTimeout(() => {
          setLoading(true);
          console.log("resMessage", resMessage);
          swal("Success", "Emails send successfully", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Emails Not Sent", "error");
      }
    });
  };
  // function to send  all text
  const sendAllText = async () => {
    swal({
      title: "Are you sure?",
      text: "Are you sure you want to send all text messages?",
      dangerMode: true,
      buttons: ["No!", "Yes"],
      icon: "warning",
      type: "warning",
      closeOnConfirm: false,
      closeOnCancel: false,
    }).then(async function (isConfirm) {
      // Redirect the user
      if (isConfirm) {
        console.log("inside confirm status");
        try {
          const ID = localStorage.getItem("accessId");
          setLoading(true);
          let res = await DEATH_API.SendEmails({
            type: "text",
            clientId: +ID,
          });
          setLoading(false);
          setTextButton(true);
          await getText();

          // swal("Success!", res.message, "success");
          // return res;
        } catch (error) {
          setLoading(false);
          console.log(error);
          throw new Error(error);
        }
        setTimeout(() => {
          setLoading(true);
          swal("Success", "Text send successfully", "success");
          setLoading(false);
        }, 0);
      } else {
        swal("Cancelled", "Text Not Sent", "error");
      }
    });
  };

  return (
    <div>
      {console.log("conatctactt", contactList)}
      {showModal && (
        <AddModal
          show={showModal}
          close={handelCloseModal}
          fields={email_field}
          modalTitle="Add New Email"
          handlechange={handlechange}
          submitData={submitData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
          handleRichTextChange={handleRichTextChange}
          handleSelectTemplateChange={handleSelectTemplateChange}
        />
      )}
      {showUpdateModal && (
        <UpdateModal
          show={showUpdateModal}
          close={handelCloseUpdateModal}
          fields={updateEmailFields}
          modalTitle="Update Email"
          handlechange={handleUpdatechange}
          submitData={SubmitUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          handleUpdateRichTextChange={handleUpdateRichTextChange}
          handleSelectUpdateTemplateChange={handleSelectUpdateTemplateChange}
          obj={updateObject}
        />
      )}
      {showTextModal && (
        <AddModal
          show={showTextModal}
          close={handelCloseTextModal}
          fields={textFields}
          modalTitle="Add New Text"
          handlechange={handlechange}
          submitData={submitTextData}
          handleDocumentChange={handleDocumentChange}
          handleDatePickerChange={handleDatePickerChange}
          handleRadioChange={handleRadioChange}
          handlePhoneChange={handlePhoneChange}
          handleSelectChange={handleSelectChange}
          handleRichTextChange={handleRichTextChange}
          handleSelectTextTemplateChange={handleSelectTextTemplateChange}
        />
      )}
      {showUpdateTextModal && (
        <UpdateModal
          show={showUpdateTextModal}
          close={handelCloseUpdateTextModal}
          fields={updateTextFields}
          modalTitle="Update Text"
          handlechange={handleUpdatechange}
          submitData={SubmitTextUpdate}
          handleDocumentChange={handleUpdateDocumentChange}
          handleDatePickerChange={handleUpdateDatePickerChange}
          handleRadioChange={handleUpdateRadioChange}
          handleUpdateSelectChange={handleUpdateSelectChange}
          handleUpdatePhoneChange={handleUpdatePhoneChange}
          handleUpdateRichTextChange={handleUpdateRichTextChange}
          handleSelectUpdateTextTemplateChange={
            handleSelectUpdateTextTemplateChange
          }
          obj={updateObject}
        />
      )}
      {showViewModal && (
        <ViewModal
          show={showViewModal}
          close={handelCloseViewModal}
          fields={updateEmailFields}
          modalTitle="View Email"
          obj={updateObject}
        />
      )}
      {showViewTextModal && (
        <ViewModal
          show={showViewTextModal}
          close={handelCloseViewTextModal}
          fields={updateTextFields}
          modalTitle="View Text"
          obj={updateObject}
        />
      )}
      <Modal
        centered
        visible={isHistoryModalOpen}
        footer={null}
        closable={false}
        onCancel={false}
      >
        <Style.ModalTitle> Email History</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              History of {updateObject && updateObject.to}
            </Style.ModalDetails>
            {emailLogs && emailLogs.length > 0 ? (
              <table id="clients">
                <tr>
                  <th>Time</th>
                  <th>Status</th>
                </tr>
                {emailLogs &&
                  emailLogs.map((data, index) => (
                    <tr key={index}>
                      <td>{moment(data.createdAt).format("MM/DD/YYYY")}</td>
                      <td>{data.status === "Send" ? "Sent" : data.status}</td>
                    </tr>
                  ))}
              </table>
            ) : (
              <Style.ModalDetails>
                {" "}
                No data to show
              </Style.ModalDetails>
            )}
          </div>
        </div>
        <Style.WrapperButtons
          style={{ display: "flex", justifyContent: "center" }}
        >
          <Style.SaveButton onClick={handleHistoryCancel}>
            Close
          </Style.SaveButton>
        </Style.WrapperButtons>
      </Modal>

      <Modal
        centered
        visible={tooltipModal}
        footer={null}
        onCancel={handleTooltipCancel}
      >
        <Style.ModalTitle> Emails & Texts</Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              {props.role !== "protrustee" && (
                <React.Fragment>
                  As mentioned in audio/video messages (feature step 2) the Plan
                  Creator can choose to leave a custom message to one or more
                  groups and to have that message delivered via email or SMS
                  text. The program designers included the ability for all users
                  to see how many emails are sent, rejected and details like
                  when opened. These added abilities should help reduce wasted
                  time with follow-ups and potentially more phone calls. This is
                  another reason to make sure you allow emails from Asset Planet
                  to go into your inbox and not to junk/spam.
                </React.Fragment>
              )}
              {props.role === "protrustee" && (
                <React.Fragment>
                  Complete these fields prior to clicking{" "}
                  <strong>“Send All Emails”</strong> below. The original email
                  message is not changed, but is supplemented with this
                  information in order to provide more details. Once you click
                  the Submit button, these eight fields will be included at the
                  bottom of each email message.
                </React.Fragment>
              )}
            </Style.ModalDetails>
          </div>
          {props.role !== "protrustee" && (
            <div
              style={{
                display: "flex",
                height: "fit-content",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              {tooltipModal && (
                <video style={{ width: "25rem" }} controls>
                  <source
                    src={
                      "https://assets-planet.s3.amazonaws.com/media/a0661b09-cebd-4591-86d2-d3c105f475ab.mp4"
                    }
                    type="video/mp4"
                  />
                </video>
              )}
            </div>
          )}
        </div>
      </Modal>
      <Modal
        centered
        visible={tooltipTextModal}
        footer={null}
        onCancel={handleTooltipTextCancel}
      >
        <Style.ModalTitle>
          {" "}
          {props.role === "protrustee"
            ? "Text Message"
            : "Sample Text Template-Friends"}
        </Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              {props.role !== "protrustee" && (
                <p>
                  Hello friends of (person who died), I am sharing sad news of
                  my death and this text is to let you know that more details
                  are included in an email from the software company I used
                  Asset Planet and WhenIDie.com. Please check your junk email
                  folder as the email will help answer questions and reduce the
                  calls to my family.
                  <br /> Your friend,
                  <br /> (person who died)
                </p>
                /*<p>
                  This is an important and serious message related to the death
                  announcement of (Plan Creator). You may have also received a
                  detailed email from{" "}
                  <a
                    style={{ color: "#2A3DA3" }}
                    href="https://whenidie.com/"
                    target="blank"
                  >
                    {" "}
                    WheniDie.com{" "}
                  </a>
                  and you can also verify on{" "}
                  <a
                    style={{ color: "#2A3DA3" }}
                    href="https://mylegacywall.com/"
                    target="blank"
                  >
                    {" "}
                    Home{" "}
                  </a>{" "}
                  . I died on (date) from (cause) and more is posted online or
                  e-mail too much for text. <br />
                  <br />
                  Here are some of my closest Trusted Individuals, and they
                  might be reaching out to you. <br />
                  #1, #2 #3 <br />
                  <br /> (custom goodbye)
                  <br />
                  <br />
                  (Plan Creator)
                </p> */
              )}
              {props.role === "protrustee" && (
                <p>
                  Text messages typically will contain less detailed information
                  than an e-mail. The text message will be brief and might
                  include an extra message for viewers to check their email and
                  possibly junk folder if an email did not arrive in the inbox.
                </p>
              )}
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      <Modal
        centered
        visible={tooltipEmailModal}
        footer={null}
        onCancel={handleTooltipEmailCancel}
      >
        <Style.ModalTitle>
          {props.role === "protrustee"
            ? "Emails"
            : "Sample Email Template – Friend"}
        </Style.ModalTitle>
        <div style={{}}>
          <div className="">
            <Style.ModalDetails>
              {props.role !== "protrustee" && (
                <p>
                  On behalf of the (Family Name), it is with sad news we share
                  with you the death of (Name). This email might also include an
                  audio or video message along with funeral details, so please
                  read through everything before contacting my spouse to lower
                  the emotional toll taken by answering the same questions.
                  <br />
                  <br />
                  Please take the time to rejoice in my life, as I was very
                  grateful and appreciative of all my blessings, including
                  having friends like you. You can post videos, pictures, or
                  your own words on my digital blog at{" "}
                  <a
                    style={{ color: "#2A3DA3" }}
                    href="https://mylegacywall.com/"
                    target="blank"
                  >
                    {" "}
                    mylegacywall.com
                  </a>
                  .
                </p>
                /* <p>
                  On behalf of the (family name) it is with sad news we share
                  with you the (death or untimely passing) of (Plan Creator
                  Name) who died on (date).
                  <br />
                  <ol>
                    <li>
                      And the family wishes for the details to remain private at
                      this time.
                    </li>
                    <li>
                      (Plan creator short name) died from (specific or general)
                      medical conditions.
                    </li>
                    <li>
                      (Plan creator short name) from an accident while (fill in
                      blank allow 120 characters).
                    </li>
                  </ol>
                  Funeral services will be held on (day and date) at (time) at
                  (name of establishment) at (address) please address.
                  <br />
                  <ol>
                    <li>appropriately for funeral</li>
                    <li>casually for weather</li>
                    <li>As you see best</li>
                    <li>
                      Favorite: (empty field allow 120 characters) e.g. sports
                      team, garment theme
                    </li>
                  </ol>
                  Optional- Following the services, we shall gather for laughter
                  and rejoice at
                  <br />
                  <ol>
                    <li>A location to be announced later</li>
                    <li>A location distributed at services.</li>
                    <li>
                      (Specific location) (empty field allow 120 characters)
                    </li>
                  </ol>
                  Optional – Family special requests
                  <br />
                  Optional - Until we gather to celebrate the life of (Plan
                  Creator) we encourage you to{" "}
                  <a
                    style={{ color: "#2A3DA3" }}
                    href="https://whenidie.com/"
                    target="blank"
                  >
                    {" "}
                    click this link{" "}
                  </a>{" "}
                  so that you can post on the digital wall of remembrance your
                  thoughts and memories of (Plan Creator nickname short name).
                  The site is open and does not require a password, only this
                  non-published link.
                  <br />
                  * From the team at Asset Planet we suggest you use this tool
                  we created with kindness and consideration as words can have
                  higher impact during this sensitive time. Honor legacy.
                  <br />
                  Optional; The services will be livestreamed{" "}
                  <a
                    style={{ color: "#2A3DA3" }}
                    href="https://whenidie.com/"
                    target="blank"
                  >
                    {" "}
                    click this link{" "}
                  </a>{" "}
                  to enroll.
                  <br />
                  Optional – Transportations or Parking Instructions are as
                  follows;
                  <br />
                  Optional- In lieu of flowers or other gifts please consider a
                  donation to (organization name) at (detail link of how to
                  give).
                  <br />
                  <br /> Sincerely,
                  <br />
                  <br />
                  <ol>
                    <li>Person</li>
                    <li>Persons (Small Group)</li>
                    <li>Family last name</li>
                    <li>Corporate Group Name</li>
                  </ol>
                  </p> */
              )}
              {props.role === "protrustee" && (
                <p>
                  Once you have completed the above fields, the next step is to
                  click Send All Emails. Once emails have been sent, you will be
                  able to see the status of each email to help you determine who
                  received, opened or clicked the email. This added feature will
                  reduce the calls needed for those who did not get the email.
                </p>
              )}
            </Style.ModalDetails>
          </div>
        </div>
      </Modal>
      {addEmailTemplate && (
        <Modal
          centered
          visible={addEmailTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <Style.ModalTitle> Create Email Template</Style.ModalTitle>
          <div style={{}}>
            <Style.Input
              id="name"
              type="text"
              placeholder="Template Name"
              name="name"
              onChange={(e) => {
                e.persist();
                console.log("eevnt value", e.target.value);
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  name: e.target.value,
                }));
              }}
            ></Style.Input>
            <ReactQuill
              id="template"
              placeholder="Template"
              name="template"
              onChange={(e) => {
                // e.persist();
                setEmailTemplateData((prevFormData) => ({
                  ...prevFormData,
                  template: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton onClick={closeEmailTemplateModal}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton id="stop" onClick={saveEmailTemplateModal}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      {addTextTemplate && (
        <Modal
          centered
          visible={addTextTemplate}
          footer={null}
          closable={false}
          onCancel={false}
        >
          <Style.ModalTitle> Create Text Template</Style.ModalTitle>
          <div style={{}}>
            <Style.Input
              id="name"
              type="text"
              placeholder="Template Name"
              name="name"
              onChange={(e) => {
                e.persist();
                console.log("eevnt value", e.target.value);
                setTextTemplateData((prevFormData) => ({
                  ...prevFormData,
                  name: e.target.value,
                }));
              }}
            ></Style.Input>
            <ReactQuill
              id="template"
              placeholder="Template"
              name="template"
              modules={{ toolbar: false }}
              onChange={(e) => {
                // e.persist();
                setTextTemplateData((prevFormData) => ({
                  ...prevFormData,
                  template: e,
                }));
              }}
            ></ReactQuill>
          </div>
          <Style.WrapperButtons>
            <Style.CancelButton onClick={closeTextTemplateModal}>
              Cancel
            </Style.CancelButton>
            <Style.SaveButton id="stop" onClick={saveTextTemplateModal}>
              Save
            </Style.SaveButton>
          </Style.WrapperButtons>
        </Modal>
      )}
      <Style.MainHeading>
        {/* <Style.HeaderImg src={Safe} alt="Safe"></Style.HeaderImg> */}
        <div style={{display:'flex', alignItems:'baseline', columnGap:'3px'}}>
          Emails and Texts to Send After Death{" "}
          <ToolTipCreator name={"Death_Emails_and_Texts_to_Send_After_Death"}/>
        </div>
        {/* <Style.HelpIcon
          src={helpIcon}
          alt="helpicon"
          onClick={() => {
            showTooltipModal();
          }}
        ></Style.HelpIcon> */}
      </Style.MainHeading>
      {props.role === "protrustee" && (
        <div>
          <h3
            className="text-center font-weight-bold"
            style={{ marginTop: "30px", marginBottom: "30px" }}
          >
            Please add this information before sending Emails and Text Messages
          </h3>

          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Funeral Date">
                {funeralData["funeralDate"] && (
                  <DatePicker
                    defaultValue={moment(funeralData.funeralDate)}
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                    }}
                    format={"MM/DD/YYYY"}
                    size={"large"}
                    name="funeralDate"
                    onChange={(date, dateString) =>
                      handleFormDateChange("funeralDate", date, dateString)
                    }
                  />
                )}
                {!funeralData["funeralDate"] && (
                  <DatePicker
                    // defaultValue={moment(this.state.FuneralData.funeralDate)}
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                    }}
                    format={"MM/DD/YYYY"}
                    size={"large"}
                    name="funeralDate"
                    onChange={(date, dateString) =>
                      handleFormDateChange("funeralDate", date, dateString)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Funeral Location">
                <Style.Input
                  defaultValue={funeralData ? funeralData.funeralLocation : ""}
                  size={"large"}
                  onChange={handleFunearlChange}
                  name="funeralLocation"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Time of Arrival">
                <Style.Input
                  defaultValue={funeralData ? funeralData.timeOfArrival : ""}
                  size={"large"}
                  onChange={handleFunearlChange}
                  name="timeOfArrival"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Gifts / Flowers">
                <Style.Input
                  defaultValue={funeralData ? funeralData.gift : ""}
                  size={"large"}
                  onChange={handleFunearlChange}
                  name="gift"
                />
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Charity URL">
                <Style.Input
                  defaultValue={funeralData ? funeralData.charityUrl : ""}
                  onChange={handleFunearlChange}
                  name="charityUrl"
                ></Style.Input>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Passed Away From">
                <Style.Input
                  defaultValue={funeralData ? funeralData.passedAwayFrom : ""}
                  size={"large"}
                  onChange={handleFunearlChange}
                  name="passedAwayFrom"
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="Passed Away On">
                {funeralData["passedAwayOn"] && (
                  <DatePicker
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                    }}
                    format={"MM/DD/YYYY"}
                    size={"large"}
                    name="passDate"
                    defaultValue={moment(funeralData.passedAwayOn)}
                    // defaultValue={moment(this.state.FuneralData ? this.state.FuneralData.passedAwayOn : "")}
                    // defaultValue={moment(this.state.FuneralData ? this.state.FuneralData.passedAwayOn : "", dateFormat)}
                    onChange={(date, dateString) =>
                      handleFormDateChange("passedAwayOn", date, dateString)
                    }
                  />
                )}
                {!funeralData["passedAwayOn"] && (
                  <DatePicker
                    style={{
                      width: "100%",
                      border: "1px solid #d1d5db",
                      borderRadius: "5px",
                    }}
                    format={"MM/DD/YYYY"}
                    size={"large"}
                    name="passDate"
                    onChange={(date, dateString) =>
                      handleFormDateChange("passedAwayOn", date, dateString)
                    }
                  />
                )}
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <Form.Item label="My Legacy Wall URL">
                <Style.Input
                  defaultValue={funeralData ? funeralData.legacyUrl : ""}
                  onChange={handleFunearlChange}
                  name="legacyUrl"
                ></Style.Input>
              </Form.Item>
            </Col>
          </Row>
          <Row gutter={16} type="flex" justify="center">
            <Col span={16}>
              <div
                className="d-flex justify-content"
                style={{ marginBottom: "1rem", justifyContent: "center" }}
              >
                <Style.SaveButton
                  onClick={async () => {
                    submitForm();
                  }}
                >
                  Submit
                </Style.SaveButton>
              </div>
            </Col>
          </Row>
        </div>
      )}

      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Emails
            <Style.HelpIcon
              src={helpIcon}
              alt="helpicon"
              onClick={() => {
                showTooltipEmailModal();
              }}
            ></Style.HelpIcon>
          </Style.Title>
          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  // setShowModal(true);
                  setDropDownEmail(!dropDownEmail);
                  setDropDownText(false);
                  setDropdown(false);
                  console.log("emailFieldstemaple", templateValue);
                }}
              >
                +
              </Style.Button>
              {dropDownEmail && (
                <>
                  <div
                    onClick={() => {
                      setDropDownEmail(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div
                    class="dropdown"
                    style={{
                      width: "250px",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      zIndex: "9999",
                    }}
                  >
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setAddEmailTemplate(true);
                          setDropDownEmail(false);
                        }}
                      >
                        Create Template
                      </li>
                      <li
                        className="liHover"
                        onClick={() => {
                          setShowModal(true);
                          setDropDownEmail(false);
                        }}
                      >
                        Add Email
                      </li>
                    </ul>
                  </div>
                </>
              )}{" "}
            </div>
          )}
          {props.role === "protrustee" && (
            <div>
              <Style.SendButton onClick={sendAllEmails} disabled={emailButton}>
                Send All Emails
              </Style.SendButton>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={emailCols} rows={emails}></List>
      </Style.HealthCard>
      <Style.HealthCard>
        <Style.HealthCardHeader>
          <Style.Title style={{}}>
            Texts{" "}
            <Style.HelpIcon
              src={helpIcon}
              alt="helpicon"
              onClick={() => {
                showTooltipTextModal();
              }}
            ></Style.HelpIcon>
          </Style.Title>

          {props.role !== "protrustee" && (
            <div>
              <Style.Button
                onClick={() => {
                  // setTextShowModal(true);
                  setDropDownText(!dropDownText);
                  setDropDownEmail(false);
                  setDropdown(false);
                }}
              >
                +
              </Style.Button>
              {dropDownText && (
                <>
                  <div
                    onClick={() => {
                      setDropDownText(false);
                    }}
                    className=""
                    style={{
                      position: "fixed",
                      width: "100vw",
                      height: "100vh",
                      background: "black",
                      opacity: "0.1",
                      top: "0",
                      left: "0",
                      right: "0",
                      bottom: "0",
                      zIndex: "999",
                    }}
                  ></div>

                  <div
                    class="dropdown"
                    style={{
                      width: "250px",
                      fontSize: "12px",
                      fontFamily: "Poppins",
                      zIndex: "9999",
                    }}
                  >
                    <ul className="dropdownul">
                      <li
                        className="liHover"
                        onClick={() => {
                          setAddTextTemplate(true);
                          setDropDownText(false);
                        }}
                      >
                        Create Template
                      </li>
                      <li
                        className="liHover"
                        onClick={() => {
                          setTextShowModal(true);
                          setDropDownText(false);
                        }}
                      >
                        Add Text
                      </li>
                    </ul>
                  </div>
                </>
              )}
            </div>
          )}
          {props.role === "protrustee" && (
            <div>
              <Style.SendButton onClick={sendAllText} disabled={textButton}>
                Send All Texts
              </Style.SendButton>
            </div>
          )}
        </Style.HealthCardHeader>
        <List cols={textCols} rows={text}></List>
      </Style.HealthCard>
      {props.role === "protrustee" && (
        <Style.HealthCard>
          <Style.HealthCardHeader>
            <Style.Title style={{}}>Email Stats</Style.Title>
          </Style.HealthCardHeader>
          <ListPaginated cols={LogsCountCols} rows={logsCount}></ListPaginated>
        </Style.HealthCard>
      )}
      <Loader isLoading={loading} />
    </div>
  );
};
